var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.blockingContainer},[_c('fulfilling-bouncing-circle-spinner',{attrs:{"animation-duration":2000,"size":65,"color":_vm.$style['v-dark']}}),(_vm.text)?_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }